import { I18n } from "@assets/strings";
import React from "react";
import { ClipLoader } from "react-spinners";
import styled from "styled-components";
import { useQuiz, useQuizParticipantAnswer } from "@domain/lms/quiz/hooks";
import { ClosableModal } from "@ui/modals/closableModal";
import { gap } from "@ui/styles/utils";
import { stack } from "@ui/components/layout";
import { QuizView } from "./quizView";

interface QuizModalProps extends React.HTMLAttributes<HTMLDivElement> {
	quizId: string;
	source?: string;
	close: () => void;
}
export const QuizModal: React.FC<QuizModalProps> = ({ quizId, source, close, ...htmlProps }) => {
	const { result: quiz, loading, error } = !source ? useQuiz(quizId) : useQuizParticipantAnswer(quizId, source);
	return (
		<Container {...htmlProps} close={close}>
			{quiz ? (
				<QuizView
					quiz={quiz}
					isAuthor={source ? true : false}
					onFinish={() => {
						document.querySelector(".modal-backdrop")?.scrollTo(0, 0);
					}}
				/>
			) : error?.code === 404 ? (
				<MissingQuiz>
					<div>
						<div>{I18n.t("404.oops")}</div>
						<div>{I18n.t("404.quiz")}</div>
					</div>
					<div>404!</div>
				</MissingQuiz>
			) : loading ? (
				<ClipLoader />
			) : null}
		</Container>
	);
};

const Container = styled(ClosableModal)`
	width: 550px;
	min-height: 250px;
	${gap(40)};
`;

const MissingQuiz = styled.div`
	${stack(40, "center", "center")};
	padding: 40px;
	flex: 1;
	font-weight: 700;
	text-align: center;
	> :first-child {
		${({ theme }) => theme.textStyles.primary};
	}
	> :last-child {
		${({ theme }) => theme.textStyles.titleBig};
		font-weight: 700;
		color: ${({ theme }) => theme.colors.secondary};
	}
`;
